var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('h2',[_vm._v(_vm._s(_vm.orgName))]),_c('h3',[_vm._v(_vm._s(_vm.year)+"年 - "+_vm._s(_vm.scoreName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }